import { Div, H2 } from 'honorable'

import DesignSystemSubSectionFonts from '~components/scene-design/DesignSystemSubSectionFonts'

function DesignSystemSectionTypography() {
  return (
    <Div xflex="y2s">
      <H2 mb={2}>Typography</H2>
      <DesignSystemSubSectionFonts />
    </Div>
  )
}

export default DesignSystemSectionTypography
